import Homework from './Homework';

export default Homework;
